import changePasswordTemplate from './changePassword.tpl.html';

export class ChangePassword {
  constructor($scope, $ngRedux, actionsFactory, $state) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $state,
    });
    this.unsubscribe = $ngRedux.connect(ChangePassword.mapStateToThis, actionsFactory)(this);
  }

  $onInit() {
    this.currentPassword = null;
    this.password = null;
    this.passwordConfirmation = null;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  changePassword() {
    this.changePasswordRequest(this.currentPassword, this.password, this.passwordConfirmation);
  }

  goToHome() {
    this.state(this.navigation.home.state, this.navigation.home.params);
  }

  static mapStateToThis(state) {
    return {
      change: state.changePassword,
      navigation: state.navigation,
    };
  }
}

ChangePassword.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$state',
];

export const changePassword = {
  template: changePasswordTemplate,
  controller: ChangePassword,
};
